export default __webpack_public_path__ + "static/media/O-083.3d1fde05.png";